module.exports = __webpack_public_path__ + "img/trash-default.daf0a27c.svg";